import(/* webpackMode: "eager" */ "/codebuild/output/src3202864701/src/apps/fanychance/src/app/error.tsx");
